import * as React from 'react';
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import SearchIcon from "@mui/icons-material/Search";



export default function InputComponent({value, callback}){
  const [inputValue, setValue] = React.useState()
  return (
    <><TextField value={inputValue}  onChange={(e) => {
      setValue(e.target.value)
    }}
                 sx={{width:'90%', textAlign:'left', outline:'none'}} size={"small"}/>
      <Button variant={'contained'} sx={{ borderRadius: 0, boxShadow:'none', py: 1.15}} size={"small"} onClick={() => {callback(inputValue)}}><SearchIcon/></Button>

    </>
  )
}